/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Proof_Drop_HintInputs */

const vi_tea_purchase_payment_proof_drop_hint = /** @type {(inputs: Tea_Purchase_Payment_Proof_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kéo ảnh vào đây hoặc`)
};

/**

* @param {Tea_Purchase_Payment_Proof_Drop_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_proof_drop_hint = /** @type {((inputs?: Tea_Purchase_Payment_Proof_Drop_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Proof_Drop_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_proof_drop_hint(inputs)
});